import React from 'react';
import { useNavigate } from 'react-router-dom';
import logoHeader from '../assets/logo_header.png';

const Expired = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#FCFAF7] flex flex-col items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-lg p-8 text-center">
        <img 
          src={logoHeader} 
          alt="Shaun Dju Academy" 
          className="h-12 mx-auto mb-8"
        />
        <div className="w-20 h-20 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg className="w-10 h-10 text-yellow-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <h1 className="text-2xl font-bold text-[#203D32] mb-4">Payment Expired</h1>
        <p className="text-gray-600 mb-8">
          Your payment session has expired. Please try again to complete your registration.
        </p>
        <button
          onClick={() => navigate('/#checkout-section')}
          className="bg-[#203D32] text-white px-8 py-3 rounded-full font-semibold hover:opacity-90 transition"
        >
          Try Again
        </button>
      </div>
    </div>
  );
};

export default Expired; 